<template>
  <div v-show="runenv!='miniprogram'">
    <div class="foot-content" :class="{ 'foot-fixed': showType == 2 }" v-if="modata">
      <div class="rowCenter download-section" v-if="showSection">
        <div class="download-name download-name_left">
          <p class="text-3xl p1">{{modata.downloadTitle}}</p>
          <p class="text-base p2">{{modata.downloadDescribe}}</p>
        </div>
        <div class="download-image" v-if="modata.downloadImgUrl">
          <img
            class="img"
            :src="modata.downloadImgUrl"
          />
        </div>
        <div class="">
          <div class="download-name download-name_right">
             <p class="text-3xl p1">{{modata.downloadTitle}}</p>
             <p class="text-base p2">{{modata.downloadDescribe}}</p>
          </div>
          <div class="rowCenter download-code">
            <div class="center grid mr-40" v-if="modata.downloadCodeUrl1">
              <div class="imgbox">
                <img class="img" :src="modata.downloadCodeUrl1" />
              </div>
              <p class="text-sm mgb15">{{modata.downloadCodeName1}}</p>
            </div>
            <div class="center grid"  v-if="modata.downloadCodeUrl2">
              <div class="imgbox">
                <img class="img" :src="modata.downloadCodeUrl2" />
              </div>
              <p class="text-sm mgb15">{{modata.downloadCodeName2}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="text-sm row foot-section">
        <div class="foot-left">
          <div class="rowCenter link" v-if="modata.footNav && modata.footNav.length>0">
            <a href="javascript:;" class="mr-6" v-for="(item,index) in modata.footNav" @click="pageNavigate(item.linkUrl)" :key="index">{{item.name}}</a>
          </div>
          <div class="rowCenter filings filings_top">
            <span class="mr-2">©{{companyData.companyName||"安亿仕电子科技有限公司"}}</span>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              class="rowCenter mr-2"
            >
              <img class="beian" src="@/assets/images/beian.png" alt />
              <span>{{companyData.filingsNumb||"粤ICP备17051504号-1"}}</span>
            </a>
          </div>
        </div>
        <div class="rowCenter foot-right">
          <template v-for="(item,index) in modata.footOfficial">
             <el-popover
                placement="top-start"
                trigger="hover"
                :visible-arrow="false"
                popper-class="wx-popover"
                :key="index"
                v-if="item.jumpType==2"
              >
                <div class="rowCenter download-code" v-if="item.popList && item.popList.length">
                  <div class="grid" v-for="(child,numb) in item.popList" :key="index+'_'+numb">
                    <div class="imgbox" >
                      <img class="img" :src="child.imgUrl" />
                    </div>
                    <p class="text-sm" v-if="child.name">{{child.name}}</p>
                  </div>
                </div>
                <div class="rowCenter pointer item" slot="reference">
                  <img class="icon" :src="item.imgUrl" alt />
                  <span class="name">{{item.title}}</span>
                </div>
              </el-popover>
              <a href="javascript:;" class="rowCenter item" @click="pageNavigate(item.linkUrl)" :key="index" v-else>
                <img class="icon" :src="item.imgUrl" alt />
                <span class="name">{{item.title}}</span>
              </a>

          </template>

        </div>
        <div class="rowCenter filings filings_bottom">
           <span class="mr-2">©{{companyData.companyName||"安亿仕电子科技有限公司"}}</span>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              class="rowCenter mr-2"
            >
              <img class="beian" src="@/assets/images/beian.png" alt />
              <span>{{companyData.filingsNumb||"粤ICP备17051504号-1"}}</span>
            </a>
          </div>
      </div>
    </div>
     <div class="foot-content" :class="{ 'foot-fixed': showType == 2 }" v-else>
      <div class="text-sm row foot-section">
        <div class="foot-left">
          <div class="rowCenter filings filings_top">
            <span class="mr-2">©{{companyData.companyName||"安亿仕电子科技有限公司"}}</span>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              class="rowCenter mr-2"
            >
              <img class="beian" src="@/assets/images/beian.png" alt />
              <span>{{companyData.filingsNumb||"粤ICP备17051504号-1"}}</span>
            </a>
          </div>
        </div>

      </div>
    </div>


    <div class="foot-back" v-if="showType == 2">
      <div class="back1" v-if="showSection"></div>
      <div class="back2"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "footView",
  props: {
    showSection: {
      type: Boolean,
      default: true,
    },
    showType: {
      type: Number,
      default: 1, //1默认  2定位
    },
  },
   computed: {
    ...mapGetters(
      {modata: 'footData',companyData: 'configData',runenv: 'runenv'},
    ),
  },
  components: {},
  data() {
    return {};
  },
  mounted() {},
  created() {},

  methods: {

      pageNavigate(path){
          if(!path){
              return
          }
          if(/^(https?:|mailto:|tel:)/.test(path)){
          window.open(path)
          }else{
              this.$router.push(path)
          }
      },
  },
};
</script>
<style scoped lang="scss">
.foot-back {
  .back1 {
    height: 630px;
  }
  .back2 {
    height: 170px;
  }
}

.foot-fixed {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 90;
}

.download-section {
  translate: none;
  rotate: none;
  scale: none;
  transform: translate(0px, 0px);
  opacity: 1;
  visibility: inherit;
  padding: 76px 80px 0;
  justify-content: space-evenly;
  background-color: rgb(246 247 248/1);
  color: #12151a;

  .img {
    width: 100%;
    height: 100%;
  }
  .mr-40 {
    margin-right: 40px;
  }

  .p2 {
    margin-top: 20px;
    color: rgba(18, 21, 26, 0.6);
  }

  .download-image {
    width: 260px;
    height: 386px;
    flex: none;
  }
}

.download-code {
  text-align: center;
  .grid+.grid{
   margin-left: 20px;
  }
 .imgbox {
    display: block;
    padding: 8px;
    width: 150px;
    height: auto;
    background-color: #fff;
    margin-bottom: 16px;
  }
  // .imgbox2 {
  //   padding: 8px;
  //   width: 248px;
  //   height: auto;
  // }
  .img {
    width: 100%;
    height: 100%;
  }
}

.foot-section {
  padding: 40px;
  background-color: #12151a;
  color: hsla(0, 0%, 100%, 0.8);
  justify-content: space-between;
  a {
    color: hsla(0, 0%, 100%, 0.8);
  }
  .beian {
      width: 23px;
      height: 23px;
      margin-right: 3px;
    }
  .foot-left {
    min-width: 407px;
    .link {
      margin-bottom: 22px;
    }
    .filings {
      color: hsla(0, 0%, 100%, 0.3);
      a {
        color: hsla(0, 0%, 100%, 0.3);
      }
    }
  }


  .foot-right {
    flex-wrap: wrap;
    justify-content: flex-end;
    .item {
      padding: 12px 10px;
      margin-right: 20px;
    }
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

  .download-code .grid+.grid{
   margin-left: 20px;
  }
  }

}
.download-name_right{
 display: none;
 margin-bottom: 24px;
}
.filings_bottom{
   display: none;
 margin-top: 20px;
}
//

@media  (min-width: 750px) and (max-width: 1280px) {
  .download-section {
      padding: 56px 46px 0;
      .download-name_left{
        display: none;
      }
      .download-name_right{
        display: block;
      }
      .mr-40{
        margin-right: 16px;
      }
    
  }

  .foot-section{
    .foot-right {
      .item{margin-right: 8px;}
    }
  }
}

@media (max-width: 750px) {
  .download-section{
    flex-direction: column;
      .download-name_left{
        display: block;
        margin-bottom: 20px;
      }
      .download-name_right{
        display: none;
      }
      .download-code{
        display: none;
      }

  }

  .foot-section{
    flex-direction: column;
    align-items: center;
    .foot-right {
      justify-content: center;
      .item{margin-right: 8px;}
      .name{display: none;}
    }
    .filings_top{display: none;}
    .filings_bottom{display: flex;}

    
  }




  
}



</style>

<style>
.wx-popover {
  background-color: #12151a;
  padding: 10px;
  border-color: #888;
}
</style>